

import './style.css'
import { v4 as uuid } from 'uuid';
import TableColumn from '../TableColumn'
import React, { Component } from 'react';
import { erase, add, edit } from '../CRUD'
import { H3, Text } from 'components/texts';
import { enqueueSnackbar } from 'notistack';
import Statics from 'objects/common/Statics';
import AddIcon from '@mui/icons-material/Add';
import { libroPedidoObject } from './constants'
import RemoveIcon from '@mui/icons-material/Remove';
import { Button } from 'components/forms/components'

export default class LibrosPedidos extends Component {

    constructor(props){
        super(props)

        this.state = {
            librosPedidos: this.props.librosPedidos ?? [],
            cursoEscolar: null,
        }
    }


    componentDidUpdate(prevProps) {
        if(prevProps.cursoEscolar != this.props.cursoEscolar)
            this.setState({cursoEscolar: this.props.cursoEscolar})

        if(prevProps.librosPedidos != this.props.librosPedidos)
            this.setState({librosPedidos: this.props.librosPedidos})
    }


    updateLibrosPedidos = (librosPedidos) => {
        this.props.onUpdate([...librosPedidos])
    }


    render() {
        const librosToRender = this.state.cursoEscolar ? this.state.librosPedidos.filter(item => item.id_curso_escolar == this.state.cursoEscolar && item.deleted != true) ?? [] : []
        const sumPedidas     = Statics.sumParamsOfObjectArray(librosToRender, "cantidad_pedida")
        const sumLlegadas    = Statics.sumParamsOfObjectArray(librosToRender, "cantidad_llegada")

        return (
            <>
                <H3>Libros pedidos: </H3>
                <table className='libros-pedidos-table'>
                    <thead>
                        <tr>
                            <th></th>
                            <th><Text fontWeight={"bold"}>Fecha</Text></th>
                            <th><Text fontWeight={"bold"}>Unidades pedidas</Text></th>
                            <th><Text fontWeight={"bold"}>Unidades llegadas</Text></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody className='no-border'>
                        {librosToRender.map((item, index, array) => (
                            <tr key={uuid()}>
                                <td className='bg-white'>
                                    <Button style={{borderRadius: 200}} color={"error"} onClick={() => {
                                        const librosPedidos = erase(item, this.state.librosPedidos)
                                        this.updateLibrosPedidos(librosPedidos)
                                    }} iconType>
                                        <RemoveIcon/>
                                    </Button>
                                </td>
                                
                                <TableColumn defaultValue={item.fecha} type={"date"} onEdit={(value) => {
                                    const librosPedidos = edit(item, value, "fecha", this.state.librosPedidos)
                                    this.updateLibrosPedidos(librosPedidos)
                                }}/>

                                <TableColumn defaultValue={item.cantidad_pedida} onEdit={(value) => {
                                    const librosPedidos = edit(item, value, "cantidad_pedida", this.state.librosPedidos)
                                    this.updateLibrosPedidos(librosPedidos)
                                }}/>

                                <TableColumn defaultValue={item.cantidad_llegada} onEdit={(value) => {
                                    const librosPedidos = edit(item, value, "cantidad_llegada", this.state.librosPedidos)
                                    this.updateLibrosPedidos(librosPedidos)
                                }}/>

                                {array.length === index + 1 && this.state.cursoEscolar ? (
                                    <td className='bg-white'>
                                        <Button iconType onClick={() => {
                                            const librosPedidos = add(librosToRender, this.state.librosPedidos, this.state.cursoEscolar, libroPedidoObject)
                                            librosPedidos ? this.updateLibrosPedidos(librosPedidos) : enqueueSnackbar(<Text>Rellena el pedido anterior para añadir más.</Text>, { variant: "error" })
                                        }}>
                                            <AddIcon/>
                                        </Button>
                                    </td>
                                ) : null}
                            </tr>
                        ))}

                        {librosToRender.length == 0 && this.state.cursoEscolar ? (
                            <tr>
                                <td className='bg-white' colSpan={4}></td>
                                <td className='bg-white'>
                                    <Button iconType onClick={() => {
                                        const librosPedidos = add(librosToRender, this.state.librosPedidos, this.state.cursoEscolar, libroPedidoObject)
                                        librosPedidos ? this.updateLibrosPedidos(librosPedidos) : enqueueSnackbar(<Text>Rellena el pedido anterior para añadir más.</Text>, { variant: "error" })
                                    }}>
                                        <AddIcon/>
                                    </Button>
                                </td>
                            </tr>
                        ): null}

                        <tr className="total-unidades">
                            <td colSpan={2} className='bg-white'><Text fontWeight="bold">Total unidades</Text></td>
                            <td><Text>{sumPedidas}</Text></td>
                            <td><Text>{sumLlegadas}</Text></td>
                        </tr>
                    </tbody>
                </table>

            </>
        ); 
    }
};